import React, {FunctionComponent, useState, Fragment, CSSProperties} from "react";
import {Box, ClickAwayListener, Typography, useMediaQuery} from "@material-ui/core";
import SvgButton from "./SvgButton";
import InfoIcon from "../images/Icons/info_icn.svg";
import theme from "../theme";

type InfoBoxProps = {
    text: string;
    buttonContainerStyle?: CSSProperties;
    infoBoxContainerStyle?: CSSProperties;
    infoSize?: number;
};

const InfoBox: FunctionComponent<InfoBoxProps> = ({text, buttonContainerStyle, infoBoxContainerStyle, infoSize}) => {

    const [open, setOpen] = useState<boolean>(false);

    const isXs = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <Fragment>
            <SvgButton
                svg={InfoIcon}
                onMouseLeave={isXs ? undefined : () => setOpen(prevState => !prevState)}
                onMouseEnter={isXs ? undefined : () => setOpen(prevState => !prevState)}
                onClick={isXs ? () => setOpen(prevState => !prevState): undefined}
                style={buttonContainerStyle}
                size={infoSize}
            />
            {open &&
            <ClickAwayListener onClickAway={isXs ? () => setOpen(prevState => !prevState) : () => undefined}>
                <Box
                    style={{
                        width: 125,
                        padding: 4,
                        backgroundColor: "#555555",
                        position: "absolute",
                        zIndex: 100,
                        marginTop: 4,
                        right: 11,
                        borderRadius: "7px 0px 7px 7px",
                        boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.2)",
                        ...infoBoxContainerStyle
                    }}>
                    <Typography style={{
                        textAlign: "center",
                        fontSize: 10,
                        letterSpacing: 0.16,
                        color: "#EEEEEE",
                        lineHeight: "14px"
                    }}>
                        {text}
                    </Typography>
                </Box>
            </ClickAwayListener>}
        </Fragment>
    );
};

export default InfoBox;
